export default function TrustSection() {
  return (
    <section className="relative py-24 md:py-32 bg-gradient-to-b from-background-50 to-primary-50/40">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-[13px] font-semibold text-foreground-400 uppercase tracking-[0.1em] mb-6 whitespace-nowrap">
          DLACZEGO WARTO ZAUFAĆ NASZEJ BAZIE?
        </p>

        <div className="space-y-5">
          <p className="text-xl md:text-2xl text-foreground-800 leading-relaxed font-body max-w-[720px] mx-auto">
            <strong className="font-semibold text-foreground-900">Kakobuy Sheet</strong> to największy w Polsce, niezależny arkusz produktowy łączący ponad <strong className="font-semibold text-foreground-900">1000 zweryfikowanych produktów</strong> z chińskich platform zakupowych.
          </p>
          <p className="text-xl md:text-2xl text-foreground-700 leading-relaxed font-body max-w-[720px] mx-auto">
            Nasza baza <strong className="font-semibold text-foreground-900">Kakobuy Finds</strong> jest codziennie aktualizowana, aby zapewnić Ci dostęp do najświeższych okazji, sprawdzonych sprzedawców i dokładnych opisów produktów.
          </p>
          <p className="text-xl md:text-2xl text-foreground-700 leading-relaxed font-body max-w-[720px] mx-auto">
            Niezależnie od tego, czy szukasz sneakersów, modnych ubrań, elektroniki czy akcesoriów — nasz <strong className="font-semibold text-foreground-900">Kakobuy Spreadsheet</strong> to Twoje kompleksowe narzędzie do bezpiecznych i świadomych zakupów.
          </p>
          <p className="text-xl md:text-2xl text-foreground-700 leading-relaxed font-body max-w-[720px] mx-auto">
            Dołącz do tysięcy zadowolonych użytkowników, którzy codziennie korzystają z naszej bazy, by oszczędzać czas i pieniądze.
          </p>
        </div>

        <div className="mt-10">
          <span className="text-3xl">✨</span>
        </div>
      </div>
    </section>
  );
}